import controller from './box-products.controller';
import templateDefault from './templates/box-products-base.view.html';
import templateT1 from './templates/box-products-t1.view.html';
import templateT2 from './templates/box-products-t2.view.html';
import templateT3 from './templates/box-products-t3.view.html';
import templateT4 from './templates/box-products-t4.view.html';
import templateT5 from './templates/box-products-t5.view.html';
import templateT6 from './templates/box-products-t6.view.html';
import templateT10 from './templates/box-products-t10.view.html';
import templateT11 from './templates/box-products-t11.view.html';
import templateT13 from './templates/box-products-t13.view.html';
import templateT15 from './templates/box-products-t15.view.html';
import templateAD from './templates/box-products-adaptative.html';

let BoxProductsComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<',
        itemName: '@',
        category:'<',
        useCategory:'<',
        origin:'@',
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');
  if(__env.adaptative){return templateAD;}
  else{
    if(response.BOX_PRODUCTS.component == 'template_t1'){return templateT1}
    else if(response.BOX_PRODUCTS.component == 'template_t2'){return templateT2}
    else if(response.BOX_PRODUCTS.component == 'template_t3'){return templateT3}
    else if(response.BOX_PRODUCTS.component == 'template_t4'){return templateT4}
    else if(response.BOX_PRODUCTS.component == 'template_t5'){return templateT5}
    else if(response.BOX_PRODUCTS.component == 'template_t6'){return templateT6}
    else if(response.BOX_PRODUCTS.component == 'template_t10'){return templateT10}
    else if(response.BOX_PRODUCTS.component == 'template_t11'){return templateT11}
    else if(response.BOX_PRODUCTS.component == 'template_t13'){return templateT13}
    else if(response.BOX_PRODUCTS.component == 'template_t15'){return templateT15}
    else {return templateDefault;}
  }
}

export default BoxProductsComponent;


/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/catalog/box-products/box-products.component.js
 **/